import { Box } from "@mui/material";
import styled from "styled-components";

export const ClientDetailsStyled = styled(Box)`
  .form {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
`;

export const ClientCardWrapper = styled.div`
position: relative;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &.opened {
    border: 2px solid #2460b8;
    background-color: #f0f8ff;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 12px;

    > div {
      flex: 1;
      margin-right: 16px;

      &:last-child {
        margin-right: 0; 
      }
    }
  }

  .row2 {
    /* display: grid;
    grid-template-columns: 140px 1fr; */
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      gap: 10px;
    }

    > div {
      display: flex;
      flex-direction: column;
    }
  }

  .label {
    font-weight: bold;
    font-size: 14px;
    color: #555;
    margin-bottom: 4px;
  }

  .value {
    font-size: 14px;
    color: #333;
  }
`;
